import styled from 'styled-components';

export const CategorySidebarWrapper = styled.div`
    background-color: #F3F5F9;
    padding: 30px 0;
`;



// WEBPACK FOOTER //
// ./assets/js/styles/CategoryPage.ts